import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { DateTimePipe } from '../directives/datetime.pipe';
import { CultureService } from '../services/culture.service';

export interface HeaderExam {
    dateTime: string;
}

export interface HeaderPatient {
    firstName: string;
    lastName: string;
    sex: string;
    birthDate: Date;
}

export class HeaderInformation {
    left: string;
    center: string;
    right: string;
}

const EMPTY_HEADER: HeaderInformation = {
    left: '',
    center: '',
    right: '',
};

@Injectable({
    providedIn: 'root',
})
export class HeaderService {
    private headerSubject = new BehaviorSubject<HeaderInformation>(EMPTY_HEADER);

    constructor(private cultureService: CultureService) {}

    get header$() {
        return this.headerSubject.asObservable();
    }

    isHeaderEmpty(header: HeaderInformation) {
        return !header || !header.left || !header.center || !header.right;
    }

    clear() {
        this.headerSubject.next(EMPTY_HEADER);
    }

    setEstensaHeader(exam: HeaderExam, centerContent: string, patient: HeaderPatient) {
        const leftContent = this.buildLeftContent(exam);
        const rightContent = this.buildRightContent(patient);

        this.setHeader(leftContent, centerContent, rightContent);
    }

    setPatient(patient: HeaderPatient) {
        const rightContent = this.buildRightContent(patient);
        this.setHeader(null, null, rightContent);
    }

    setExam(exam: HeaderExam) {
        const leftContent = this.buildLeftContent(exam);
        this.setHeader(leftContent, null, null);
    }

    private buildLeftContent(exam: HeaderExam) {
        const dateTimePipe = new DateTimePipe(this.cultureService.getCulture());
        const dateTime = dateTimePipe.transform(exam.dateTime, this.cultureService.getShortDateTimePattern());

        return 'EXAM_DATE' + ' ' + dateTime;
    }

    private buildRightContent(patient: HeaderPatient) {
        const dateTimePipe = new DateTimePipe(this.cultureService.getCulture());
        const birthDate = dateTimePipe.transform(patient.birthDate, this.cultureService.getShortDatePattern());

        return (
            patient.lastName +
            ' ' +
            patient.firstName +
            (patient.sex == null ? ' ' : ' (' + patient.sex + ') ') +
            (birthDate == null ? '' : birthDate)
        );
    }

    private setHeader(left: string, center: string, right: string) {
        this.headerSubject.next({
            left,
            center,
            right,
        });
    }
}
